import { sendBackendPagination } from "../../common/utils/pagination";
import { ICryptoCurrency } from "../../interfaces/crypto-currency/ICryptoCurrency";
import { IListPagination } from "../../interfaces/pagination/IListPagination";
import { IPagination } from "../../interfaces/pagination/IPagination";
import { cryptoPortfolioService } from "../../services/httpService/cryptoPorfolio.service";

export async function tryGetCryptoCurrencyList(cryptoCurrencyName?: string) {
    if (cryptoCurrencyName){
        return await cryptoPortfolioService.get<ICryptoCurrency[]>(`/cryptocurrency/getcryptocurrencylist?cryptoCurrencyName=${cryptoCurrencyName}`); 
    }

    return await cryptoPortfolioService.get<ICryptoCurrency[]>('/cryptocurrency/getcryptocurrencylist');
}

export async function tryUpdateCryptoCurrencyList() {
    return await cryptoPortfolioService.put('/cryptocurrency/updatecryptolist');
}

export async function tryCreateCryptoCurrencyUser(cryptoCurrency: ICryptoCurrency) {
    return await cryptoPortfolioService.post('/cryptocurrencyuser/create', cryptoCurrency);
}

export async function tryGetCryptoCurrencyByUserIdList(pagination: IPagination) {
    return await cryptoPortfolioService.get<IListPagination<ICryptoCurrency>>(
         `/cryptocurrencyuser/getcryptocurrencylist?page=${sendBackendPagination(pagination.page)}&pageSize=${pagination.rowsPerPage}`);
}

export async function tryDeleteCryptoCurrencyById(id: string) {
    return await cryptoPortfolioService.delete(`/cryptocurrencyuser/delete/${id}`);
}

export async function tryToUpdateCryptoCurrencyPrices() {
    return await cryptoPortfolioService.put('/cryptocurrencyuser/updateprices');
}

export async function tryGetCryptoCurrencyListByUser() {
    return await cryptoPortfolioService.get<ICryptoCurrency[]>('/cryptocurrencyuser/getcryptocurrencylistbyuser');
}

export async function tryGetStableCoinListByUser() {
    return await cryptoPortfolioService.get<ICryptoCurrency[]>('/cryptocurrencyuser/getstablecoinlistbyuser');
}